<template>
  <el-dialog
    :visible="isOpen"
    :show-close="false"
    class="egl-dialog-elm channel-dialog personal"
    :title="$locale('membership.memberList.dialog.personal.edit')"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <el-form
      :model="propForm"
      ref="detailForm"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <!-- 漢字(姓) -->
          <el-form-item :label="$locale('membership.memberList.dialog.personal.dialog.chineseLastName')">
            <el-input v-model="propForm.chineseLastName" placeholder="例) ヤマダ" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 漢字(名) -->
          <el-form-item :label="$locale('membership.memberList.dialog.personal.dialog.chineseFirstName')">
            <el-input v-model="propForm.chineseName" placeholder="例) タロウ" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- フリガナ(姓) -->
          <el-form-item :label="$locale('membership.memberList.dialog.personal.dialog.lastName')">
            <el-input v-model="propForm.japaneseLastName" placeholder="例) ヤマダ" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- フリガナ(名) -->
          <el-form-item :label="$locale('membership.memberList.dialog.personal.dialog.firstName')">
            <el-input v-model="propForm.japaneseName" placeholder="例) タロウ" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 生年月日 -->
          <el-form-item :label="$locale('membership.memberList.dialog.personal.dialog.birthday')">
            <!-- <el-input v-model="propForm.birthday" placeholder="例) ヤマダ" /> -->
            <CommDatePicker
              v-model="propForm.birthday"
              :value.sync="propForm.birthday"
              width="100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 電話番号 -->
          <el-form-item :label="$locale('accountReceivable.phone')">
            <el-input v-model="propForm.mobile" placeholder="例) 08000000000" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- 性別 -->
          <el-form-item :label="$locale('membership.memberList.dialog.personal.gender')">
            <GroupBtns
              :parentValue.sync="propForm.gender"
              :parentList="getMemberGender()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- 郵便番号（半角） -->
          <el-form-item :label="$locale('membership.memberList.dialog.personal.dialog.postalCode')">
            <el-row>
              <el-col :span="10">
                <NumberInput v-model="propForm.postalCode1" :value.sync="propForm.postalCode1" placeholder="例) 123" :maxLength="3" :isAreaCode="true" />
              </el-col>
              <el-col :span="4" style="display: flex;justify-content: center;">ー</el-col>
              <el-col :span="10">
                <NumberInput v-model="propForm.postalCode2" :value.sync="propForm.postalCode2" placeholder="例）4567" :maxLength="4" :isAreaCode="true" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="13">
          <!-- 都道府県 -->
          <el-form-item :label="$locale('setting.emergency.perfecture')">
            <el-input v-model="propForm.prefecture" placeholder="例）東京都" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- 市区町村 -->
          <el-form-item :label="$locale('setting.cinema.city')">
            <el-input v-model="propForm.city" placeholder="例）中央区" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- 番地・建物名・部屋番号など -->
          <el-form-item :label="$locale('membership.memberList.dialog.personal.dialog.streetAddress')">
            <el-input v-model="propForm.address" placeholder="例）中央区" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- メールアドレス -->
          <el-form-item :label="$locale('global.email')">
            <el-input v-model="propForm.email" placeholder="例）abcd@mail.com" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- お知らせメール -->
          <el-form-item label="お知らせメール">
            <el-select v-model="propForm.receiveNews" :placeholder="$locale('form.plsSelect')">
              <el-option label="受信する" :value="true"></el-option>
              <el-option label="受信しない" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="20" type="flex" justify="center" style="margin-top: 117px;">
        <el-col :span="16" style="display: flex; justify-content: space-around;">
          <template>
            <el-button class="egl-btn-white" style="width: 250px;" @click="$emit('update:isOpen', false)">
              {{ $locale("global.cancel") }}
            </el-button>
            <el-button class="egl-btn-yellow" @click="save_fn" style="width: 250px;background-color: rgba(249, 218, 73, 0.5);">
              {{ $locale("global.save") }}
            </el-button>
          </template>
        </el-col>
      </el-row>
  </el-dialog>
</template>
<script>
import GroupBtns from '@/components/common/GroupBtns/GroupBtns.vue'
import { getMemberGender } from "@/assets/js/membership"
import NumberInput from '@/components/common/NumberInput.vue';
import { updateUserInfoService } from "@/helpers/service/api/membership";
import countDownAlert from "@/utils/countDownAlert";
import CommDatePicker from "@/components/common/CommDatePicker";


export default {
  inject: ["getListDetail_fn"],
  data() {
    return {
      getMemberGender,
    }
  },
  methods: {
    save_fn() {
      updateUserInfoService({
        userId: this.propForm.userId,
        userInfo: {
          ...this.propForm,
          postalCode: `${this.propForm.postalCode1}-${this.propForm.postalCode2}`,
        }
      }).then(res => {
        if (res.success) {
          countDownAlert({ content: this.$locale("global.updateSuccessfully"), callback: () => {
            this.getListDetail_fn(this.propForm.userId)
            this.$emit('update:isOpen', false)
          }})
        }
      })
    }
  },
  components: {
    GroupBtns,
    NumberInput,
    CommDatePicker
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    propForm: {
      type: Object,
      default: {}
    }
  }
}
</script>
<style></style>